import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdFaceUnlock, MdOutlineLightMode } from 'react-icons/md';
import { SvgEyeglassesIcon, SvgChildHatIcon } from '@kiper/ui';
import { useFacialRegistrationContext } from '../../../../../../store/FacialRegistration';
import { CheckboxTerm } from './common';
import StepLayout from './StepLayout';
import * as S from './styles';

const TERMS_PRIVACY_POLICY_URL =
  'https://privacidade.portergroup.com.br/politica-de-privacidade';

const StepPreparation = () => {
  const [t] = useTranslation('personalized-invite');
  const {
    nextStep,
    primaryColor,
    secondaryColor,
    goToInvitePage,
  } = useFacialRegistrationContext();

  const [termsAccepted, setTermsAccepted] = useState(false);

  const tips = [
    { icon: MdFaceUnlock, text: t('facial-registration.tips.center-face') },
    {
      icon: MdOutlineLightMode,
      text: t('facial-registration.tips.good-lighting'),
    },
    {
      icon: SvgChildHatIcon,
      text: t('facial-registration.tips.no-accessories'),
    },
    {
      icon: SvgEyeglassesIcon,
      text: t('facial-registration.tips.no-dark-glasses'),
    },
  ];

  const footer = (
    <S.WrapperFooter>
      <CheckboxTerm
        id="terms-checkbox"
        checked={termsAccepted}
        onChange={e => setTermsAccepted(e.target.checked)}
        accentColor={primaryColor}
        linkColor={secondaryColor}
      >
        <span>
          {t('facial-registration.preparation.terms-prefix')}
          <S.TermsLink
            href={TERMS_PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            color={secondaryColor}
          >
            {t('facial-registration.preparation.terms-link')}
          </S.TermsLink>
        </span>
      </CheckboxTerm>
      <S.PrimaryButton
        disabled={!termsAccepted}
        onClick={nextStep}
        color={primaryColor}
      >
        {t('facial-registration.preparation.continue-button')}
      </S.PrimaryButton>
    </S.WrapperFooter>
  );

  return (
    <StepLayout footer={footer} onBack={goToInvitePage}>
      <S.StepTitle>{t('facial-registration.preparation.title')}</S.StepTitle>
      <S.StepDescription>
        {t('facial-registration.preparation.description')}
      </S.StepDescription>

      <S.TipsContainer>
        <S.TipsHeader>{t('facial-registration.tips.header')}</S.TipsHeader>
        <S.TipsList>
          {tips.map(tip => (
            <S.TipItem key={tip.text}>
              <S.TipIcon>
                <tip.icon size={18} color={secondaryColor} />
              </S.TipIcon>
              <span>{tip.text}</span>
            </S.TipItem>
          ))}
        </S.TipsList>
      </S.TipsContainer>
    </StepLayout>
  );
};

export default StepPreparation;
